export const ApplicationGrid = () => {
  const applications = [
    {
      title: 'Copy Paper',
      headline: 'Superior Runnability',
      description: 'Achieve high stiffness and bulk opacity while significantly reducing wood pulp usage.',
      icon: 'ri-file-copy-line',
      image: 'https://public.readdy.ai/ai/img_res/c8601708a525a4aca5f4b16a0526b753.jpg',
      benefits: ['High Stiffness', 'Bulk Opacity', 'Reduced Pulp Usage']
    },
    {
      title: 'Thermal Paper',
      headline: 'Optimized Base Sheet',
      description: 'Provides a smooth, flawless surface essential for thermal coating efficiency and base sheet strength.',
      icon: 'ri-printer-line',
      image: 'https://readdy.ai/api/search-image?query=High%20quality%20thermal%20paper%20roll%20with%20smooth%20flawless%20surface%2C%20professional%20thermal%20printing%20paper%2C%20pristine%20white%20base%20sheet%20with%20perfect%20coating%2C%20industrial%20product%20photography%2C%20clean%20and%20technical%20aesthetic%2C%20navy%20blue%20and%20white%20color%20scheme%2C%20microscopic%20smooth%20texture%20visible%2C%20premium%20thermal%20paper%20manufacturing%20quality%2C%20professional%20lighting%20highlighting%20surface%20perfection&width=600&height=400&seq=fcc-thermal-paper&orientation=landscape',
      benefits: ['Smooth Surface', 'Coating Efficiency', 'Enhanced Strength']
    },
    {
      title: 'Label Paper',
      headline: 'High Tensile Strength',
      description: 'Enhanced durability for die-cutting performance and cost-efficient production.',
      icon: 'ri-price-tag-3-line',
      image: 'https://readdy.ai/api/search-image?query=Premium%20label%20paper%20with%20high%20tensile%20strength%2C%20durable%20white%20label%20sheets%20for%20die-cutting%2C%20professional%20industrial%20label%20paper%20manufacturing%2C%20clean%20and%20precise%20label%20material%2C%20navy%20blue%20and%20white%20industrial%20aesthetic%2C%20high%20quality%20paper%20texture%2C%20cost-efficient%20production%20material%2C%20professional%20product%20photography%20with%20technical%20precision%2C%20strong%20and%20durable%20paper%20surface&width=600&height=400&seq=fcc-label-paper&orientation=landscape',
      benefits: ['Tensile Strength', 'Die-Cutting Performance', 'Cost Efficiency']
    }
  ];

  return (
    <section id="applications" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Transforming Paper Manufacturing
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            FCC Technology delivers breakthrough performance across critical paper applications
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {applications.map((app, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl overflow-hidden border border-slate-700 hover:border-amber-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-amber-500/20"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={app.image}
                  alt={app.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>
                <div className="absolute top-6 left-6 w-14 h-14 bg-amber-500 rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${app.icon} text-white text-2xl`}></i>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-3">
                  {app.title}
                </h3>
                <h4 className="text-xl font-semibold text-amber-400 mb-4">
                  {app.headline}
                </h4>
                <p className="text-gray-400 mb-6 leading-relaxed">
                  {app.description}
                </p>

                <div className="space-y-3">
                  {app.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-amber-400 rounded-full mr-3"></div>
                      <span className="text-sm text-gray-300 font-medium">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
